/** Same access rules the curriculum page already used: future units stay open. */
export function isCurriculumUnitAccessible(
  unitIndex: number,
  enrollmentDate: string,
  isOpenToAll: boolean
): { accessible: boolean; message?: string; daysLeft?: number } {
  if (isOpenToAll) {
    return { accessible: true };
  }

  if (!enrollmentDate) {
    return { accessible: false, message: 'تاريخ التسجيل غير متوفر' };
  }

  const enrollment = new Date(enrollmentDate);
  const now = new Date();
  const daysSinceEnrollment = Math.floor(
    (now.getTime() - enrollment.getTime()) / (1000 * 60 * 60 * 24)
  );

  const unitStartDay = unitIndex * 7;
  const unitEndDay = (unitIndex + 1) * 7;

  if (daysSinceEnrollment >= unitStartDay && daysSinceEnrollment < unitEndDay) {
    const daysLeft = unitEndDay - daysSinceEnrollment;
    return { accessible: true, daysLeft };
  }

  if (daysSinceEnrollment < unitStartDay) {
    return { accessible: true };
  }

  return {
    accessible: false,
    message: 'انتهت فترة الوصول لهذه الوحدة',
  };
}

export function getCurriculumUnitAccessStatus(
  unitIndex: number,
  enrollmentDate: string,
  isOpenToAll: boolean
) {
  const status = isCurriculumUnitAccessible(unitIndex, enrollmentDate, isOpenToAll);

  if (status.accessible && status.daysLeft !== undefined) {
    return {
      ...status,
      statusText: `متاحة (${status.daysLeft} ${status.daysLeft === 1 ? 'يوم متبقي' : 'أيام متبقية'})`,
      statusColor: status.daysLeft <= 2 ? 'text-orange-600' : 'text-green-600',
    };
  }

  if (status.accessible && isOpenToAll) {
    return {
      ...status,
      statusText: 'متاحة دائماً',
      statusColor: 'text-green-600',
    };
  }

  return {
    ...status,
    statusText: status.message || 'غير متاحة',
    statusColor: 'text-red-600',
  };
}
